import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Menu } from '../dropdown';

export const CompactMenu = styled(Menu)`
  background: var(--coolest-gray-10);
  font-size: var(--font-size-base);
  border-bottom: none;
  margin-top: calc(-1 * var(--spacing-03));
  margin-left: var(--spacing-01);
  padding-top: var(--spacing-04);
  padding-bottom: 0;
  width: unset;
  &.ant-menu-horizontal {
    overflow-y: clip;
  }
  &.ant-menu.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,
  & .ant-menu-item {
    min-width: auto;
    padding-right: 0px;
    padding-left: 0px;
    margin: 0px;
    margin-right: var(--spacing-05);
  }
  & .ant-menu-item-only-child,
  .ant-menu-submenu {
    border-bottom: none;
  }
  &.ant-menu.ant-menu-horizontal:not(.ant-menu-dark)
    > .ant-menu-item-only-child:hover {
    color: var(--gray-80);
    border-bottom: 2px solid var(--cool-gray-50);
  }

  &.ant-menu.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected {
    border-bottom: 2px solid var(--blue-60);
  }
  &.ant-menu.ant-menu-horizontal:not(.ant-menu-dark)
    > .ant-menu-item-selected:hover {
    border-bottom: 2px solid var(--blue-60);
  }
  & .ant-menu,
  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,
  & .ant-menu.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
    border-bottom: none;
  }
  & .ant-badge,
  &.ant-badge-not-a-wrapper {
    margin-right: var(--spacing-02);
  }
`;

const CompactTitle = styled.span`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
`;

export const TabIcon = styled.div`
  margin-right: var(--spacing-03);
  position: relative;
  top: 3px;
  color: var(--gray-70);
`;

export const CompactMenuTitle: FC<{
  icon?: JSX.Element | null;
  text?: ReactNode | string;
}> = ({ icon, text }) => {
  return (
    <CompactTitle data-cy={`tab-${text}`}>
      {icon != null && <TabIcon>{icon}</TabIcon>}
      {text}
    </CompactTitle>
  );
};
